// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"109":"__federation_expose_WorkspaceMgmtApp","826":"__federation_expose_WorkspaceMgmtRoutes"}[chunkId] || chunkId) + "." + {"25":"4a6590159f6d7f97","109":"93e47a141acb7a13","322":"f4dd31821c2b1994","613":"ff3a31e1dca0b395","826":"324f105c791c4d6f"}[chunkId] + ".js";
};